
import { GeneticsMapGroup, GeneticsMap } from '@/services/crossbreeding-service/models';
import { Component, Prop, Vue } from 'vue-property-decorator';
import SimulationMap from './SimulationMap.vue';

@Component({ components: { SimulationMap } })
export default class HighlightedMap extends Vue {
  @Prop({ type: GeneticsMap, required: true }) map: GeneticsMap;

  handleClearHighlightClick() {
    this.$emit('clear-highlight-clicked');
  }

  handleHighlightComposingSaplingSelectedEvent(group: GeneticsMapGroup) {
    this.$emit('composing-sapling-selected', group);
  }
}
